import { render } from "./WorkflowSelector.vue?vue&type=template&id=3965725f&scoped=true"
import script from "./WorkflowSelector.vue?vue&type=script&lang=js"
export * from "./WorkflowSelector.vue?vue&type=script&lang=js"

import "./WorkflowSelector.vue?vue&type=style&index=0&id=3965725f&lang=css"
import "./WorkflowSelector.vue?vue&type=style&index=1&id=3965725f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3965725f"]])

export default __exports__